module.exports = __webpack_public_path__ + "assets/img/107@3x.f44db36f.png";